//focus on input
document.querySelector('#' + (new URLSearchParams(window.location.search)).get('focus'))?.focus();

//autosize textareas
document.querySelectorAll('.autosize').forEach(function (element) {
    element.style.height = element.scrollHeight + 'px';
});

//textarea insertion
document.insertAtCursor = function (myFieldId, myValue) {
    let myField = document.getElementById(myFieldId);
    let originalFieldValue = myField.value.trim();
    let selectionStart = myField.selectionStart;
    let selectionEnd = myField.selectionEnd;
    let textareaLength = myField.value.trim().length;

    let newFieldValue = originalFieldValue.substring(0, selectionStart).trim();
    newFieldValue += (selectionStart > 0) ? "\n\n" : '';
    newFieldValue += myValue;
    newFieldValue += (selectionEnd < textareaLength) ? "\n\n" : '';
    newFieldValue += originalFieldValue.substring(selectionEnd, textareaLength).trim();
    newFieldValue += "\n";

    myField.value = newFieldValue;

    myField.setSelectionRange(selectionStart, selectionStart + myValue.length);
};
